<template>
  <router-link v-if="eventData" :to="{ name: 'eventDetail', params: { uuid: eventData.data.uuid } }">
    <div class="mt-4 event-container" ref="containerRef" :style="{ aspectRatio: computedAspectRatio }">
      <img v-if="isWideContainer" class="banner-image"
           :src="getImageUrl(eventData.data.image_wide)" alt=""/>
      <img v-else class="banner-image"
           :src="getImageUrl(eventData.data.image)" alt=""/>

      <!-- Pass parentWidth & parentHeight into EventTopRanking -->
      <EventTopRanking
        :rank1User="rank1User"
        :rank2User="rank2User"
        :rank3User="rank3User"
        :isWideContainer="isWideContainer"
        :parentWidth="containerWidth"
      />
    </div>
  </router-link>
</template>

<script>
import {urlImage} from '@/helpers/common'
import eventsService from '@/services/events.service'
import EventTopRanking from '@/components/Events/EventTopRanking.vue'

export default {
  name: 'EventBanner',
  components: { EventTopRanking },

  data () {
    return {
      eventData: null,
      intervalId: null,
      containerWidth: 0,
      breakpointPx: 800,
      aspectRatio: 3.2,
      wideAspectRatio: 7.2
    }
  },

  computed: {
    // Are we above the “wide” breakpoint?
    isWideContainer () {
      return this.containerWidth >= this.breakpointPx
    },

    // Dynamically switch aspect ratio
    computedAspectRatio () {
      const ratio = this.isWideContainer
        ? this.wideAspectRatio
        : this.aspectRatio
      return `${ratio} / 1`
    },

    // Top-3 users from API
    rank1User () {
      return this.eventData?.ranks?.[0] || null
    },
    rank2User () {
      return this.eventData?.ranks?.[1] || null
    },
    rank3User () {
      return this.eventData?.ranks?.[2] || null
    }
  },

  async mounted () {
    // 1) fetch event data & start polling
    await this.fetchActiveEvent()
    this.startPolling()

    // 2) measure banner size after render
    this.$nextTick(() => {
      const el = this.$refs.containerRef
      if (!el) return

      // Set initial width/height
      this.containerWidth = el.offsetWidth

      // Observe future resizes
      this.resizeObserver = new ResizeObserver(entries => {
        for (let entry of entries) {
          const newWidth = entry.contentRect.width;
          window.requestAnimationFrame(() => {
            if (newWidth !== this.containerWidth) {
              this.containerWidth = newWidth;
            }
          });
        }
      })
      this.resizeObserver.observe(el)
    })
  },

  beforeDestroy () {
    if (this.intervalId) clearInterval(this.intervalId)
    if (this.resizeObserver) this.resizeObserver.disconnect()
  },

  methods: {
    async fetchActiveEvent () {
      const res = await eventsService.getActiveEvent()
      if (res.data) {
        this.eventData = res
        this.$emit('loaded')
      }
    },

    startPolling () {
      if (this.intervalId) clearInterval(this.intervalId)
      const intervalTime = this.eventData ? 10000 : 20000
      this.intervalId = setInterval(async () => {
        await this.fetchActiveEvent()
      }, intervalTime)
    },

    getImageUrl (path) {
      return urlImage({ image: path })
    }
  }
}
</script>

<style scoped>
.event-container {
  position: relative;
  width: 100%;
  overflow: hidden;
  border-radius: 1rem;
  /* aspect-ratio is provided dynamically by :style above */
}

.banner-image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}
</style>
